import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProjectSearchResultWrapper = styled.div`
  margin: 19px 0px 39px;

  ${responsive.MOBILE`
    margin: 16px 0px 0px;  
  `}

  .form-header {
    background-color: ${COLORS.primary_light_blue2};
    padding: 10px 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }

  .MuiPaper-root.MuiTableContainer-root {
    border-radius: 0;
  }

  .MuiGrid2-root {
    width: 100%;
  }
  .project-name-link {
    width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 2px 9px 4px 9px;
    border-radius: 8px;
    margin-left: 8px;
    height: 28px;
  }
`;
